
<script>
import http from '@/service/http'
import { mapState } from 'vuex'
import { ListSelect } from 'vue-search-select'
export default {
  name: 'Form',
  components: {
    ListSelect
  },
  data () {
    return {
      comoConheceu: [{}],
      status: [{}],
      clientes: [],
      itemCliente: {
        id: '',
        cliente: ''
      },
      contato: {
        id: '',
        cliente_id: '',
        tipo: 1,
        nome: '',
        cpf: '',
        cnpj: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        tipo_residencia: '',
        condominio: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia: '',
        mensagem: '',
        obs: '',
        como_conheceu_id: '',
        status_id: 1,
        foto1: '',
        foto2: '',
        foto3: '',
        foto4: '',
      }
    }
  },
  mounted () {
    this.fecth()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id != null) {
        this.fecth()
      }
    }
  },
  methods: {
    setEndereco () {
      window.$.getJSON(`https://viacep.com.br/ws/${this.contato.cep}/json/`)
      .then(response => {
        if (!response.erro) {
          this.contato.logradouro = response.logradouro
          this.contato.bairro = response.bairro
          this.contato.cidade = response.localidade
          this.contato.estado = response.uf
          $('#numero').focus()
        } else {
          this.contato.logradouro = ''
          this.contato.numero = ''
          this.contato.complemento = ''
          this.contato.bairro = ''
          this.contato.cidade = ''
          this.contato.estado = ''
        }
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      })
    },
    async fecth () {
      this.clear()
      const { id } = this.$route.params
      if (id !== undefined) {
        const { data } = await http.get(`/contatos/${id}/edit`)
        this.contato = data.contato
        this.status = data.status
        this.comoConheceu = data.comoConheceu
        this.clientes = data.clientes
      } else {
        const { data } = await http.get(`/contatos/create`)
        this.status = data.status
        this.comoConheceu = data.comoConheceu
        this.clientes = data.clientes
      }
      setTimeout(function () {
        window.Materialize.updateTextFields()
      }, 0)
    },
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          return false
        } else {
          this.submit()
        }
      })
    },
    async submit () {
      const verb = this.isNew ? 'post' : 'put'
      const url = this.isNew ? '/contatos' : `/contatos/${this.contato.id}`
      const { data } = await http[verb](url, this.contato)
      if (data != null) {
        if (data.orcamento != null) {
          this.$router.push({ name: 'orcamentos.form', params: { id: data.orcamento.id } })
        } else {
          this.$emit('update-contatos-list', {contato: data.contato})
          this.$router.push({name: 'contatos.index'})
        }
      }
    },
    onSelectCliente (item) {
      if (item) {
        this.setCliente(item.id)
      }
    },
    async setCliente (value) {
      this.contato.cliente_id = value
      if (value) {
        const {data} = await http.get(`/clientes/${value}`)
        this.$swal({
          title: `Deseja utilizar os dados do cliente ${data.cliente.cliente}?`,
          html: '',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero atualizar!',
          reverseButtons: true
        }).then(async () => {
          this.contato.tipo = data.cliente.tipo
          this.contato.cnpj = data.cliente.cnpj
          this.contato.condominio = data.cliente.razao_social
          this.contato.nome = data.cliente.tipo === 1 ? data.cliente.responsavel : data.cliente.cliente
          this.contato.cpf = data.cliente.cpf
          this.contato.email = data.cliente.email
          this.contato.telefone = data.cliente.telefone
          this.contato.telefone2 = data.cliente.telefone2
          this.contato.telefone3 = data.cliente.telefone3
          this.contato.cep = data.cliente.cep
          this.contato.logradouro = data.cliente.logradouro
          this.contato.numero = data.cliente.numero
          this.contato.complemento = data.cliente.complemento
          this.contato.bairro = data.cliente.bairro
          this.contato.cidade = data.cliente.cidade
          this.contato.estado = data.cliente.estado
          this.contato.referencia = data.cliente.referencia
          setTimeout(function () {
            window.Materialize.updateTextFields()
          }, 0)
        })
      }
    },
    clear () {
      this.contato = {
        id: '',
        cliente_id: '',
        tipo: 1,
        nome: '',
        cpf: '',
        cnpj: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        tipo_residencia: '',
        condominio: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia: '',
        mensagem: '',
        obs: '',
        como_conheceu_id: '',
        status_id: 1
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    isNew () {
      return this.contato.id === ''
    },
    api_url () {
      return process.env.UPLOADS_URL
    }
  }
}
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div class="row">

            <div class="input-field col s12 m6">
              <list-select :list="clientes"
                           option-value="id"
                           option-text="cliente"
                           style="margin-top: 10px"
                           :selected-item="itemCliente"
                           placeholder="Buscar Cliente"
                           @select="onSelectCliente">
              </list-select>
            </div>

            <div class="col s12 m3">
              <label for="tipo">*Tipo</label>
              <select name="tipo" id="tipo" v-validate data-vv-rules="required" :class="{invalid: errors.has('tipo')}" v-model.number="contato.tipo">
                <option value="1">Pessoa Jurídica</option>
                <option value="2">Pessoa Física</option>
              </select>
              <small class="red-text">{{ errors.first('tipo') }}</small>
            </div>

            <div class="input-field col s12 m3" v-show="contato.tipo === 1">
              <input name="cnpj" id="cnpj" type="text" v-mask="'99.999.999/9999-99'" v-validate data-vv-rules="min:18" :class="{invalid: errors.has('cnpj')}" v-model="contato.cnpj">
              <label for="cnpj">CNPJ</label>
              <small class="red-text">{{ errors.first('cnpj') }}</small>
            </div>

            <div class="input-field col s12 m3" v-show="contato.tipo === 2">
              <input name="cpf" id="cpf" type="text" v-mask="'999.999.999-99'" v-validate
                     data-vv-rules="min:14" :class="{invalid: errors.has('cpf')}"
                     v-model="contato.cpf">
              <label for="cpf">CPF</label>
              <small class="red-text">{{ errors.first('cpf') }}</small>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12 m4">
              <input name="nome" id="nome" type="text" v-validate data-vv-rules="required" :class="{invalid: errors.has('nome')}" v-model="contato.nome">
              <label for="nome">*Nome</label>
              <small class="red-text">{{ errors.first('nome') }}</small>
            </div>

            <div class="input-field col s12 m4">
              <input name="tipo_residencia" id="tipo_residencia" type="text" :class="{invalid: errors.has('tipo_residencia')}" v-model="contato.tipo_residencia">
              <label for="tipo_residencia">Tipo de Residência</label>
              <small class="red-text">{{ errors.first('tipo_residencia') }}</small>
            </div>

            <div class="input-field col s12 m4">
              <input name="condominio" id="condominio" type="text" :class="{invalid: errors.has('condominio')}" v-model="contato.condominio">
              <label for="condominio">Condomínio</label>
              <small class="red-text">{{ errors.first('condominio') }}</small>
            </div>

          </div>

          <div class="row">
            <div class="input-field col s12 m3">
              <input name="telefone" id="telefone" type="text" v-mask="'(99) 99999999[9]'" v-validate data-vv-rules="min:13" :class="{invalid: errors.has('telefone')}" v-model="contato.telefone">
              <label for="telefone">Telefone</label>
              <small class="red-text">{{ errors.first('telefone') }}</small>
            </div>
            <div class="input-field col s12 m3">
              <input name="telefone2" id="telefone2" type="text" v-mask="'(99) 99999999[9]'" v-validate data-vv-rules="min:13" :class="{invalid: errors.has('telefone2')}" v-model="contato.telefone2">
              <label for="telefone2">Telefone</label>
              <small class="red-text">{{ errors.first('telefone2') }}</small>
            </div>
            <div class="input-field col s12 m3">
              <input name="telefone3" id="telefone3" type="text" v-mask="'(99) 99999999[9]'" v-validate data-vv-rules="min:13" :class="{invalid: errors.has('telefone3')}" v-model="contato.telefone3">
              <label for="telefone3">Telefone</label>
              <small class="red-text">{{ errors.first('telefone3') }}</small>
            </div>
            <div class="input-field col s12 m3">
              <input name="email" id="email" type="text" v-validate data-vv-rules="email"
                     :class="{invalid: errors.has('email')}" v-model="contato.email">
              <label for="email">E-mail</label>
              <small class="red-text">{{ errors.first('email') }}</small>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12 m3">
              <input name="cep" id="cep" type="text" v-mask="'99999-999'" v-validate
                     data-vv-rules="min:9" :class="{invalid: errors.has('cep')}"
                     @blur="setEndereco" v-model="contato.cep">
              <label for="cep">CEP</label>
              <small class="red-text">{{ errors.first('cep') }}</small>
            </div>
            <div class="input-field col s12 m5">
              <input name="logradouro" id="logradouro" type="text"
                     v-model="contato.logradouro">
              <label for="logradouro">Logradouro</label>
              <small class="red-text">{{ errors.first('logradouro') }}</small>
            </div>
            <div class="input-field col s12 m2">
              <input name="numero" id="numero" type="text" v-model="contato.numero">
              <label for="numero">Nº</label>
              <small class="red-text">{{ errors.first('numero') }}</small>
            </div>
            <div class="input-field col s12 m2">
              <input name="complemento" id="complemento" type="text"
                     v-model="contato.complemento">
              <label for="complemento">Compl.</label>
              <small class="red-text">{{ errors.first('complemento') }}</small>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12 m5">
              <input name="bairro" id="bairro" type="text" v-model="contato.bairro">
              <label for="bairro">Bairro</label>
              <small class="red-text">{{ errors.first('bairro') }}</small>
            </div>
            <div class="input-field col s12 m5">
              <input name="cidade" id="cidade" type="text" v-model="contato.cidade">
              <label for="cidade">Cidade</label>
              <small class="red-text">{{ errors.first('cidade') }}</small>
            </div>
            <div class="input-field col s12 m2">
              <input name="estado" id="estado" type="text" v-model="contato.estado">
              <label for="estado">Estado</label>
              <small class="red-text">{{ errors.first('estado') }}</small>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12">
              <input name="referencia" id="referencia" type="text" v-model="contato.referencia">
              <label for="referencia">Ponto de Referência</label>
              <small class="red-text">{{ errors.first('referencia') }}</small>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12">
              <textarea name="mensagem" id="mensagem" class="materialize-textarea" v-model="contato.mensagem"></textarea>
              <label for="mensagem">Mensagem Cliente</label>
              <small class="red-text">{{ errors.first('mensagem') }}</small>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12">
              <textarea name="obs" id="obs" class="materialize-textarea" v-model="contato.obs"></textarea>
              <label for="obs">Observações KitGás</label>
              <small class="red-text">{{ errors.first('obs') }}</small>
            </div>
          </div>

          <div class="row">

            <div class="col s12 m3 center-align" v-if="contato.foto1">
              <img :src="`${api_url}/${contato.foto1}`" style="max-width: 90%;"
                    class="pointer center-align"><br/>
              <br/>
              <br clear="all"/>
            </div>

            <div class="col s12 m3 center-align" v-if="contato.foto2">
              <img :src="`${api_url}/${contato.foto2}`" style="max-width: 90%;"
                    class="pointer center-align"><br/>
              <br/>
              <br clear="all"/>
            </div>

            <div class="col s12 m3 center-align" v-if="contato.foto3">
              <img :src="`${api_url}/${contato.foto3}`" style="max-width: 90%;"
                    class="pointer center-align"><br/>
              <br/>
              <br clear="all"/>
            </div>

            <div class="col s12 m3 center-align" v-if="contato.foto4">
              <img :src="`${api_url}/${contato.foto4}`" style="max-width: 90%;"
                    class="pointer center-align"><br/>
              <br/>
              <br clear="all"/>
            </div>

          </div>

          <div class="row">

            <div class="col s12 m4">
              <label for="como_conheceu_id">Como Conheceu</label>
              <select name="como_conheceu_id" id="como_conheceu_id" v-model="contato.como_conheceu_id">
                <option v-for="como in comoConheceu" :value="como.id">{{ como.como_conheceu }}</option>
              </select>
              <small class="red-text">{{ errors.first('como_conheceu_id') }}</small>
            </div>

            <div class="col s12 m4">
              <label for="status_id">*Status</label>
              <select name="status_id" id="status_id" v-validate data-vv-rules="required" v-model="contato.status_id">
                <option v-for="status in status" :value="status.id">{{ status.status }}</option>
              </select>
              <small class="red-text">{{ errors.first('status_id') }}</small>
            </div>

          </div>

          <div class="row">

            <div class="col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/contatos/contatos/form.vue